import '@babel/polyfill';
import { Base64 } from 'js-base64';
import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import './styles/index.scss'
import App from './App.vue'
import router from '@/router/index.js'
import store from './store'
import Print from '@/utils/print'
// 公共组件
import * as components from '@/components'

//公共过滤器
import * as filters from '@/filters'
// 全局混入
import * as mixins from '@/mixins'
Object.keys(components).forEach(key => {
    Vue.component(key, components[key])
})
Object.keys(filters).forEach(key => {
    var filterFn = filters[key]
    Vue.filter(key, filterFn)
})
Object.keys(mixins).forEach(key => {
    var mixinObj = mixins[key]
    Vue.mixin(mixinObj)
})

Vue.use(ElementUI)
Vue.use(Print)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    components: { App },
    render: function (createElement) {
        if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
            window.addEventListener('hashchange', () => {
                var currentPath = window.location.hash.slice(1)
                if (this.$route.path !== currentPath) {
                    this.$router.push(currentPath)
                }
            }, false)
        }
        return createElement(App);
    }
}).$mount('#app')
